import React, { useContext } from 'react'
import { styled } from 'linaria/react'
import UseFormatProduct from '../Hooks/UseFormatProduct'
import { theme } from '../../Theme'
import Image from '@jetshop/ui/Image/Image'
import ChannelContext from '@jetshop/core/components/ChannelContext'
import PriceSection from './PriceSection'
import { useIntl } from '@jetshop/intl'
import { ReactComponent as PrebookIcon } from '../../../svg/Prebook.svg'
import { ReactComponent as OutOfStockIcon } from '../../../svg/OutOfStock.svg'
import { ReactComponent as InStockIcon } from '../../../svg/InStock.svg'
import Link from '../Link'

const ProductCardContainer = styled.div`
   a {
      font-family: var(--font-grotesk);
      color: white;
      text-decoration: none;
   }

   &.product-card-horizontal {
      width: 100%;
      background: var(--color-white);
      box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.07);
      scale: 1;
      transition: all 0.5s ease;
   }

   .product-card-image-container {
      ${theme.below.md} {
         margin: auto;
      }
   }

   .product-card-image {
      width: 100%;
      object-fit: contain;
      border-radius: 8px 8px 0 0;
      padding: 0.5rem;
      ${theme.above.md} {
         aspect-ratio: 1/1;
         padding: 0.75rem;
      }
   }

   .product-card-sku {
      font-size: 0.688rem;
      font-family: var(--font-industry);
      font-weight: 300;
   }

   .product-card-stock {
      font-family: var(--font-grotesk);
      font-weight: 600;
      font-size: 0.75rem;
   }


   .product-card-title {
      font-family: var(--font-industry);
      font-weight: 700;
      font-size: 1rem;
      word-break: break-all;
   }

   .multiline-ellipsis {
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
   }

   .product-card-title a {
      font-family: var(--font-industry);
      color: black;
   }
`

const ProductStockContainer = styled.div`
   display: flex;
   direction: column;
   gap: 0.25rem;
`

const PackageProductCard = ({ product }) => {
   const t = useIntl()
   const { selectedChannel } = useContext(ChannelContext)

   const {
      title,
      articleNumber,
      imageUrl,
      url,
      isPreBook,
      brandName,
      buyable
   } = UseFormatProduct(product) ?? {}

   const titleWithPossibleBrandName =
      brandName && title ? `${brandName} ${title}` : title

   return (
      <ProductCardContainer className="product-card-horizontal mb-16 br-8 d-flex flex-row">
         <div className="product-card-image-container col-3 col-sm-2 col-lg-3 position-relative">
            <Link to={url}>
               <Image
                  className="product-card-image p-16"
                  src={imageUrl}
                  aspect="1:1"
               ></Image>
            </Link>
         </div>
         <div className="col-6 col-sm-7 d-flex flex-column flex-grow-1 p-16">
            <div className="product-card-sku mb-1 mt-0">
               ARTNR: {articleNumber}
            </div>
            <div className="product-card-title d-flex flex-grow-1 lh-1 mb-8 mt-0">
               <Link to={url} title={title}>
                  <span className="multiline-ellipsis">
                     {titleWithPossibleBrandName}
                  </span>
               </Link>
            </div>
            <ProductStockContainer className="row">
               <PriceSection
                  product={product}
                  selectedChannel={selectedChannel}
                  showVatIndicator={true}
               ></PriceSection>
               <div className="col-12 d-flex">
                  <span className="product-card-stock align-items-center gap-1 d-flex">
                     {isPreBook ? (
                        <>
                           <PrebookIcon></PrebookIcon>
                           <span>{t('book in advance')}</span>
                        </>
                     ) : buyable ? (
                        <>
                           <InStockIcon></InStockIcon>
                           <span>{t('in stock')}</span>
                        </>
                     ) : (
                        <>
                           <OutOfStockIcon></OutOfStockIcon>
                           <span>{t('Out of stock')}</span>
                        </>
                     )}
                  </span>
               </div>
            </ProductStockContainer>
         </div>
      </ProductCardContainer>
   )
}

export default PackageProductCard